export class CampaignVarsVO {
    public static SOURCE_URL_PARAMETER: string = "urlParameter";
    public static SOURCE_ACCOUNT_COOKIE: string = "accountCookie";
    public static SOURCE_CACHE_BREAKER: string = "cacheBreaker";

    /** Holds raw campaign vars from url parameters **/
    public data: URLSearchParams;

    /** Stores the source of the campaign variables **/
    public contextDescription: string;

    /** Name of the client class **/
    public clientObjectClassName: string;

    constructor(data: URLSearchParams = null, clientObjectClassName: string = null, source: string = null) {
        this.data = data;
        this.contextDescription = source;
        this.clientObjectClassName = clientObjectClassName;
    }
}
